import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegisterService } from '../register/register.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { LocalService } from '../../_services/local.service';
import { ResetPassword } from '../account.model';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {
  model: any = {};
  public step: number = 1;
  public nextText: string = 'Verify';
  public loading: boolean = false;
  public value: string = "1234";
  public mask: string = "0-0-0-0";
  public resetModel: ResetPassword = new ResetPassword();
  public confirmPassword:any;
  public showError:boolean=false;
  public showExceptionError:boolean=false;
  verificationCode: string | null = null;
  email: string | null = null;
  constructor(private router: Router,
    private _loginService: LoginService,
    private _authenticationService: AuthenticationService,
    private _localService:LocalService,
    private route: ActivatedRoute) {
      debugger
    this.route.queryParams.subscribe(params => {
      this.verificationCode = params['verificationCode'];
      this.email = params['email'];
    });
    debugger
  }
  ngOnInit() {
  }
  public onSubmit(value: any) {
    if(this.resetModel.Password != this.confirmPassword){
      this.showError = true;
      return;
    }
    debugger
    this.resetModel.email = this.email;
    this.resetModel.verificationCode = this.verificationCode;
    this._loginService.resetPassword(this.resetModel).subscribe(
      response => {
        debugger
        this.router.navigate(['account/login']);
      },
      err => {
        this.showExceptionError = true;
        console.log(err);

      }
    );
  }
}
